import { Children, cloneElement, isValidElement } from 'react';

export default function DataTable({
  columns = [],
  data = [],
  renderRow,
  emptyMessage = 'No data available.',
}) {
  const containerStyle = {
    width: '100%',
    overflowX: 'auto',
    boxSizing: 'border-box',
  };

  const tableStyle = {
    minWidth: 640,
  };

  const emptyStateStyle = {
    padding: '24px 16px',
    textAlign: 'center',
    color: '#6b7280',
    fontSize: 14,
  };

  return (
    <div className="table-container" style={containerStyle}>
      <table
        className={`data-table${columns.length > 4 ? ' data-table--cards' : ''}`}
        style={tableStyle}
      >
        <thead>
          <tr>
            {columns.map((column, index) => (
              <th key={column.key || index}>
                {column.label || ''}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data.length > 0 ? (
            data.map((row, index) => {
              const renderedRow = renderRow ? renderRow(row, index) : null;

              if (!isValidElement(renderedRow)) {
                return null;
              }

              const originalMouseEnter = renderedRow.props.onMouseEnter;
              const originalMouseLeave = renderedRow.props.onMouseLeave;

              const labeledChildren = Children.map(
                renderedRow.props.children,
                (child, childIndex) => {
                  if (!isValidElement(child) || child.type !== 'td') {
                    return child;
                  }

                  const column = columns[childIndex] || {};

                  return cloneElement(child, {
                    'data-label': column.label || '',
                  });
                }
              );

              return cloneElement(renderedRow, {
                key: renderedRow.key || row.id || row._id || index,
                className: [renderedRow.props.className, 'data-table__row'].filter(Boolean).join(' '),
                onMouseEnter: originalMouseEnter,
                onMouseLeave: originalMouseLeave,
              },
              labeledChildren
              );
            })
          ) : (
            <tr>
              <td colSpan={columns.length || 1} style={emptyStateStyle}>
                {emptyMessage}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
